











import Vue from "vue";
import { Prop, Component, Watch } from "vue-property-decorator";

@Component
export default class BaseRadioGroup extends Vue {
  @Prop({ type: Array }) data!: Array<any>;
  @Prop({ type: [Object, Array, String, Number] }) value!: any;
  @Prop({ type: Boolean }) inline!: Boolean; //控制行内显示
  @Prop({ type: [String, Number], default: "auto" }) width!:
    | String
    | number
    | undefined;
  @Prop({ type: [String, Number], default: "30px" }) height!:
    | String
    | number
    | undefined;

  dataInitial: boolean = false;

  mounted() {}
  get model() {
    return this.value;
  }
  set model(val: any) {
    this.$emit("input", val);
    this.$emit("change", val);
  }
}
